/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-04-24 10:41:29
 * @LastEditTime: 2020-12-16 19:46:28
 */

/**
 * 获取当月总天数
 * @param {number} year 年份
 * @param {number} month 实际月份， 1月就传1
 */
var getTotalDaysInMonth = function getTotalDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
};

var getFirstWeekDay = function getFirstWeekDay(year, month) {
  return new Date(year, month - 1, 1).getDay();
};

var isSelected = function isSelected(year, month, day, selectedList) {
  // 是否是签到日期
  var selected = false;
  selectedList.forEach(function (item) {
    if (item.split('-')[0] == year && item.split('-')[1] == month && item.split('-')[2] == day) {
      selected = true;
    }
  });
  return selected;
};

var isSpecial = function isSpecial(year, month, day, specialDays) {
  // 是否是特殊日期
  var special = false;
  (specialDays || []).forEach(function (item) {
    if (new Date(item).toDateString() == new Date(year, month - 1, day).toDateString()) {
      special = true;
    }
  });
  return special;
};

export function getDayListInMonth(year, month, selectedList, specialDays) {
  var totalDays = getTotalDaysInMonth(year, month); // 获取当月总天数

  var weekDay = getFirstWeekDay(year, month); // 当月第一天是星期几

  var dateOfLastMoth; // 上个月最有一天是几号

  if (month === 1) {
    dateOfLastMoth = getTotalDaysInMonth(year - 1, 12);
  } else {
    dateOfLastMoth = getTotalDaysInMonth(year, month - 1);
  } // const totalWeeks = (totalDays + weekDay) / 7; // 当月日历需要几周


  var extraDaysInNextMoth = 7 - (totalDays + weekDay) % 7; // 需要补齐下个月的日期数

  var daysList = Array.from({
    length: totalDays
  }).map(function (item, i) {
    return {
      value: i + 1,
      type: 'current',
      selected: isSelected(year, month, i + 1, selectedList),
      special: isSpecial(year, month, i + 1, specialDays)
    };
  });

  for (var i = 0; i < weekDay; i++) {
    var preMonth = month === 1 ? 12 : month - 1;
    var preYear = month === 1 ? year - 1 : year;
    daysList.unshift({
      value: dateOfLastMoth - i,
      type: 'prev',
      selected: isSelected(preYear, preMonth, dateOfLastMoth - i, selectedList),
      special: isSpecial(preYear, preMonth, dateOfLastMoth - i, specialDays)
    });
  }

  for (var _i = 0; _i < extraDaysInNextMoth; _i++) {
    var nextMonth = month === 12 ? 1 : month + 1;
    var nextYear = month === 12 ? year + 1 : year;
    daysList.push({
      value: _i + 1,
      type: 'next',
      selected: isSelected(nextYear, nextMonth, _i + 1, selectedList),
      special: isSpecial(nextYear, nextMonth, _i + 1, specialDays)
    });
  }

  var result = []; // 返回结果，格式为[[29, 30, 1, 2, 3, 4, 5], [6, 7, 8, 9, 10, 11, 12], ...]

  for (var _i2 = 0, len = daysList.length; _i2 < len; _i2 += 7) {
    result.push(daysList.slice(_i2, _i2 + 7));
  }

  return result;
}